import { Button, Card, Group, IconExternalLink, Modal, Select, TextArea } from "@veneer/core";
import React, { useEffect, useState } from "react";
import { SideNav } from "../shared-components/side-nav";
import { Col, Container, Row } from "react-bootstrap";
import { apiGet, apiPost,apiGetWithHeader } from "../../../services/service";
import { GET_INITIATE_COUNTRY_LIST, GET_SELECTED_LANGUAGE_LIST, POST_GETMETHONECACHETOKEN, POST_GETMETHONECHATJWTTOKEN, POST_INITIATE_CHAT_LOAD, POST_PRODUCT_INFO } from "../../../services";
import CaseItems from "@components/home-page/shared-components/case-items/case-items";
import "./initiate-chat.scss";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Trans, useTranslation } from "react-i18next";
import { HpLogo } from "../shared-components/hp-logo/hp-logo";
import Loader from "../shared-components/loader/loader";

export const InitiateChat = () => {
  const {t} = useTranslation();
  const [searchParams] = useSearchParams();
  const [pageLoad, setPageLoad] = React.useState<any>([]);
  const [getProductInfo, setProductInfo] = React.useState<any>([]);
  const [getPolyProductInfo, setPolyProductInfo] = React.useState<any>([]);
  const [problemDescription, setProblemDescription] = React.useState<string>("");
  const [hpiChatAppend, setHpiChatAppend] = React.useState<{ [key: string]: any }>({});
  const [hwintent, setHwintent] = React.useState<string>("");
  const [open, setOpen] = React.useState(true);
  const [country, setCountry] = React.useState<any>([]);
  const [countryOptions, setCountryOptions] = React.useState<any>([]);
  const [language, setLanguage] = React.useState<any>([]);
  const [languageOptions, setLanguageOptions] = React.useState<any>([]);
  const [languageAll, setLanguageAll] = React.useState<any>([]);
  const [onLoadChatAvailabilityCompleted,setOnLoadChatAvailabilityCompleted] = React.useState<boolean>(false);
  const [progress,setProgress] = React.useState<boolean>(false);
  const [isDisabled,setIsDisabled] = React.useState<boolean>(true);
  const [submittedData, setSubmittedData] = useState({countryGUID:-1,
    countryCode:"",
    countryLabel:"",
    languageGUID:-1,
    languageCode:"",
    languageLabel:""})
  const [countryAll, setCountryAll] = React.useState<any>([]);
  var hpiChat: { [key: string]: any } = {};
  

  interface FormValues {
    problemdescription: string;
  }
  
  const [errors, setErrors] = useState<Partial<FormValues>>({});
  const handleChange = (value: any) => {
    const errors: Partial<FormValues> = {};
    if (!value) {
      errors.problemdescription = 'Problem description is required';
    }
    setErrors(errors);
  };

  const navigate = useNavigate();

  const cancelBtn = (data: any) => {
    let uri = `cid=${searchParams.get("cid")}`;
    navigate(`/edit-case?${uri}`);
  }


    async function initiateChatProcess() {
      setProgress(true);
      const date = new Date();
      const payloadCheckChat = {
        scid: country[0], // Selected Country GUID
        slid: language[0],
        contactid: "85680C15-7814-E711-80FC-5065F38AD971",
        cid: searchParams.get("cid"),
        Offset: date.getTimezoneOffset(),
        
        
      };

      try {
        const pageloadres: any = await apiPost(
          POST_INITIATE_CHAT_LOAD,
          payloadCheckChat
        );

        if (pageloadres.status === 200 && pageloadres.data) {
          setPageLoad(pageloadres.data);

          try{
            const payload = {
              ainfo: pageloadres.data.serialnumber,
              pno: pageloadres.data.productnumber,
              contactid: "85680C15-7814-E711-80FC-5065F38AD971",
              
              
            };
            const productInfo: any = await apiPost(POST_PRODUCT_INFO, payload);
            if (productInfo.data) {
              setProductInfo(productInfo.data);
              setProgress(false);
            }
            setPolyProductInfo(payload)
          }catch (error) {
            console.error("Error in fetching Product info", error);
            setProgress(false);
          }
        }

      } catch (error) {
        console.error("Error in fetching initiate chat", error);
        setProgress(false);
      }
      setProgress(false);
    }


  useEffect(()=>{

    async function onLoad() {
      setProgress(true);
      try{
      const response = await apiGetWithHeader(GET_INITIATE_COUNTRY_LIST);
      if (response.status === 200 && response.data) {
        console.log("");
        console.log(response);
        if(response.data && response.data.allcountries){
        let countryList = response.data.allcountries.map(
          (items: any) => {
            return { value: items.Key, label: items.Value, shortCode: items.ShortCode };
          }
        );
        setCountryAll(countryList);
        setCountryOptions(countryList);

        if(response.data.preferredlanguagelist && response.data.preferredlanguagelist!=null){
        let languageList = response.data.preferredlanguagelist.map(
          (items: any) => {
            return { value: items.Key, label: items.Value, shortCode: items.ShortCode };
          }
        );
        setLanguageOptions(languageList);
        setLanguageAll(languageList);
        }
        
        console.log(countryOptions);
        }
        
        if(response.data.profilecountry.Key && response.data.profilecountry.Key!=null){
        setCountry([response.data.profilecountry.Key]);
        }
      }
    }catch(error){
      console.error("Error in Pre Filter Country Dropdown\n"+error);
    }
      setProgress(false);
    }
    onLoad();
  },[]);

  const onChangeCountry = async (value:any)=>{

    setLanguage([]);
    setLanguageOptions([]);
    setLanguageAll([]);
    setIsDisabled(true);
    setProgress(true);

    const payloadCountry = {
      "cname": value[0].label,
      
      
    };

  try{
    const response= await apiPost(
      GET_SELECTED_LANGUAGE_LIST,
      payloadCountry
    );

    if(response.data && response.data.languagelist.length >0){

    let languageList = response.data.languagelist.map(
      (items: any) => {
        return { value: items.Key, label: items.Value, shortCode: items.ShortCode };
      }
    );
    setLanguageOptions(languageList);
    setLanguageAll(languageList);
  }
    
  }catch(error){
    console.log("Error in countrySelectedIndexChange api",error);
  }
  setProgress(false);

  };

  useEffect(() => {
    if (pageLoad && pageLoad.ISResponse) {
      SuccessCallback(JSON.parse(pageLoad.ISResponse)[0]);
    }
  }, [pageLoad]);

  const timeDifference = (d: Date, dd: Date): number => {
    const minute = 60 * 1000;
    const hour = minute * 60;
    const day = hour * 24;
    const month = day * 30;
    let ms = Math.abs(d.getTime() - dd.getTime());

    const months = Math.floor(ms / month);
    ms -= months * month;

    const days = Math.floor(ms / day);
    ms -= days * day;

    const hours = Math.floor(ms / hour);
    ms -= hours * hour;

    const minutes = Math.floor(ms / minute);
    return minutes;
  };

  const hdnStartDateTime = new Date();


  function startChat() {
    let Now = new Date();
    let ChatStartDateTime = new Date(hdnStartDateTime);
    let remainingTime = parseInt(pageLoad?.hdnremainingOpenTime);
    let diffMins = timeDifference(ChatStartDateTime, Now);
    if (diffMins < remainingTime) {

      hpiChat = {
        ...hpiChat,
        cclsresponse: pageLoad?.hdnServiceResponse
      };

      ContinueChat();

    }

  }

  const handleSubmit = () => {
    if (validate()) {
      startChat();
    }
  };

  const validate = () => {
    const errors: Partial<FormValues> = {};
    if (!problemDescription) {
      errors.problemdescription = 'Problem description is required';
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  }

  function ContinueChat() {
    setProgress(true);
    hpiChat = {
      ...hpiChat,
      ChatinProcess: true,
      CountryCode: submittedData.countryCode[0],
      LanguageCode: submittedData.languageCode[0],
      description: problemDescription ? problemDescription : "",
      serviceUrl: JSON.parse(hpiChat.cclsresponse).ContactOptions[0].serviceUrl, //hpiChat.cclsresponse
      Fullname: pageLoad.fullname,
      emailaddress: pageLoad.emailaddress,
      hdnIsChatOpen: pageLoad.hdnIsChatOpen,
      hdnChannelName: JSON.parse(hpiChat.cclsresponse).ContactOptions[0].chatQueue,
      hdnCompanyID: JSON.parse(hpiChat.cclsresponse).ContactOptions[0].companyId
    };

    if (pageLoad.hdnServiceType === "60") {
      hpiChat = {
        ...hpiChat,
        hwintent: hwintent,
        CaseNumber: pageLoad?.ticketnumber
      };
      GetMethoneCacheToken();
    }
  }

  async function GetMethoneCacheToken() {
    const methonCacheTokenPayload = {
      casenumber: hpiChat.CaseNumber,
      caseid: hpiChat.CaseId,
      contactid: '85680C15-7814-E711-80FC-5065F38AD971',
      intent: 'MyHpSupport-NotApplicable',
      chatpbrqueue: hpiChat.hdnChannelName,
      hwintent: hpiChat.hwintent ? hpiChat.hwintent : "",
      serialnumber: pageLoad?.serialnumber,
      productnumber: pageLoad?.productnumber
    }

    try {
      const res: any = await apiPost(
        POST_GETMETHONECACHETOKEN,
        methonCacheTokenPayload
      );
      if (res.status === 200) {
        hpiChat = {
          ...hpiChat,
          CacheToken: res.data.CacheToken
        };

        hpiChat = {
          ...hpiChatAppend,
          ...hpiChat

        }

        localStorage.setItem('hpi_Chat', JSON.stringify(hpiChat));
        GetMethoneChatJWTToken();
      }
    } catch (error) {
      console.error("Error fetching Methone chat token", error);
    }

  }


  async function GetMethoneChatJWTToken() {
    const JsonInput = {
      cachetoken: hpiChat.CacheToken
    }

    try {
      const JWTres: any = await apiPost(
        POST_GETMETHONECHATJWTTOKEN,
        JsonInput
      );
      if (JWTres.status === 200) {
        localStorage.setItem('hpi_ChatJWTToken', JWTres.data.ChatJWTToken);
        navigate(`/initiate-chat/occhat`);
      }
      setProgress(false);
    } catch (error) {
      console.error("Error fetching Methone chat JWT token", error);
      setProgress(false);
    }

  }



  function SuccessCallback(response: any) {

    if (response.Assets[0]) {
      for(const value of response.Assets[0].ContractEntitlement) {
        switch (value.Status.toLowerCase()) {
          case 'future':
            setHpiChatAppend(prevState => ({
              ...prevState,
              WarrantyLevel: 'XW'
            }));
            break;
          case 'active':
            setHpiChatAppend(prevState => ({
              ...prevState,
              WarrantyLevel: 'IW'
            }));
            break;
          case 'expired':
            setHpiChatAppend(prevState => ({
              ...prevState,
              WarrantyLevel: 'OW'
            }));
            break;
          default:
            setHpiChatAppend(prevState => ({
              ...prevState,
              WarrantyLevel: 'UN'
            }));
            break;
        }

        if (['future', 'active', 'expired'].includes(value.Status.toLowerCase())) {

          var d = new Date()
          setHpiChatAppend(prevState => ({
            ...prevState,
            ProductLineCode: response.Assets[0].Product.ProductLineCode,//"MG"
            openerscreenname: 'openchat',
            SerialNumber: response.Assets[0].AssertSerialNumber,
            ProductNumber: response.Assets[0].Product.ProductId,
            Offset: d.getTimezoneOffset(),
            ProductNameOid: pageLoad.hdnProductNameOID,
            ProductName: response.Assets[0].Product.ProductName,
            CaseId: searchParams.get("cid"),
            ProductSeriesOID: ""
          }));

        } else {
          // setDivExpiredWarrantyAlert

        }

        if (value.IsBestEntitlement) {
          break;
        }
      };
    }
  }

  const onCountrySearch  = (value:any) => {
    const filteredCountryOptions = countryAll.filter((country_item:any) =>
      country_item.label.toLowerCase().includes(value.toLowerCase())
    );
    setCountryOptions(filteredCountryOptions);
  };

  const onLanguageSearch  = (value:any) => {
    const filteredLanguageOptions = languageAll.filter((language_item:any) =>
      language_item.label.toLowerCase().includes(value.toLowerCase())
    );
    setLanguageOptions(filteredLanguageOptions);
  };

  const findLabelByValue = (list:any, value:any) => {
    return list.map((country_item: { value: any; label: any; }) => {
      if (country_item.value == value) {
        return country_item.label;
      }
      return null;
    }).filter((label: null) => label !== null);
  };

  const findShotCodeByValue = (list:any, value:any) => {
    return list.map((country_item: { value: any; shortCode: any; }) => {
      if (country_item.value == value) {
        return country_item.shortCode;
      }
      return null;
    }).filter((label: null) => label !== null);
  };

  const buttonDisableCheck = (value:any,field:string)=>{
    if((country.length >0 && (value!=null && field==="language")) || (language.length >0 && (value!=null && field==="country"))) {
      return setIsDisabled(false);
    }
    return setIsDisabled(true);
  }

  const checkChatAvailability = ()=>{
    setOnLoadChatAvailabilityCompleted(true);
    let obj :any = {};
    obj.countryLabel= findLabelByValue(countryAll,country[0]);
    obj.languageLabel= findLabelByValue(languageAll,language[0]);
    obj.countryCode=findShotCodeByValue(countryAll,country[0]);
    obj.languageCode=findShotCodeByValue(languageAll,language[0]);

    initiateChatProcess();

    setSubmittedData(prevData =>({
      ...prevData,
    countryGUID:country[0],
    countryCode:obj.countryCode,
    countryLabel:obj.countryLabel,
    languageGUID:language[0],
    languageCode:obj.languageCode,
    languageLabel:obj.languageLabel
    }));
    setOpen(false);

  }

  return (<>
  {progress && (
        <div className="loader-overlay">
          <div className="loader-css">
            <Loader />
          </div>
        </div>
      )}
      <Container fluid className="bg-clr">
        <div className="initiate-Chat">
          <div className="header">
            <h2>{t('HPI.InitiateChat.Title',{defaultValue:'Initiate Chat'})}</h2>
            <Col className="supporting-text">
              <p>
                {t('HPI.InitiateChat.SupportText',{defaultValue:'Please provide as much information below to help HP Support Center solve your case.'})}
              </p>
            </Col>
          </div>
          <div>
            <Card
              // background="filled"
              border="none"
              className="bg-clr-without-margin"
              content={
                <Container className="card-container">
                  <CaseItems
                    data={getProductInfo} polyData={getPolyProductInfo}
                  />
                </Container>
              }
            />
          </div>
          <div>
          
          <Card
              background="filled"
              border="none"
              customStyle={"background-color:transparent;"}
              
              content={
                <Container className="card-container py-2 px-4 mt-4 d-flex gap-2 flex-wrap changeLang-Container">
                  <div className=" d-flex gap-3 flex-wrap align-items-center justify-content-center flex-grow-1"><p className="mb-0"><b style={{fontFamily:"'Forma DJR UI',Arial,sans-serif"}}>{t('HPI.Country',{defaultValue:'Country'})} : </b>{submittedData.countryLabel}</p><p className="mb-0"><b style={{fontFamily:"'Forma DJR UI',Arial,sans-serif"}}>{t('HPI.InitiateChat.Language',{defaultValue:'Language'})} : </b>{submittedData.languageLabel}</p></div>

                  <Button
                    // appearance="secondary"
                    onClick={() => { setOpen(true) }}
                  >
                    {t('HPI.InitiateChat.ChangeSelection',{defaultValue:'Change selection'})}
                  </Button>
                  <div style={{ position: 'relative' }}>
                    <Modal
                      align="start"
                      id="modal-id"
  
                      show={open}
                      maxWidth="650px"
                      closeOnBlur={false}
                      header={<div className="d-flex gap-2 subtitle-regular align-items-center"> <HpLogo /><h5>{t('HPI.InitiateChat.ConfirmCountry',{defaultValue:'Confirm your Country/Region and Language'})}</h5></div>}
                      footer={(
                        <div className="d-flex justify-content-end w-100 gap-2 flex-wrap">
                        {/* <Group> */}
                          <Button appearance="secondary"
                            onClick={() => { 
                              onLoadChatAvailabilityCompleted?setOpen(false):cancelBtn(true);
                               }}
                          >{onLoadChatAvailabilityCompleted?t('HPI.btnCancel',{defaultValue:'Cancel'}):t("HPI.CallMeForm.ContactOptions",{ defaultValue: 'Back to case details' })}</Button>
                          <Button
                          onClick={checkChatAvailability}
                          disabled={isDisabled}
                          
                          >{t('HPI.Chat.CheckChatAvailability',{defaultValue:'Check chat availability'})}</Button>
                        {/* </Group> */}
                        </div>
                      )}
                    >
                      <div className="changeLngHelpText body-regular">
                        <div className="d-flex gap-2">
                          <p className="w-auto">1. </p>
                          <p dangerouslySetInnerHTML={{ __html: t('HPI.InitiateChat.HelpMessage1', { defaultValue: 'You will be routed to a relevant support team based on your country and language selection.' }) }}>
                          </p>
                        </div>
                        <div className="d-flex gap-2">
                          <p className="w-auto">2. </p>
                          <p dangerouslySetInnerHTML={{ __html: t('HPI.InitiateChat.HelpMessage2', { defaultValue: 'Hardware & replacement requests may be limited if you choose a country different from your profile country.' }) }}>
                          </p>
                        </div>
                        <br />
                        <p><b>{t('HPI.InitiateChat.Note', { defaultValue: 'Note' })}:</b>{t('HPI.InitiateChat.OptionHelpText', { defaultValue: 'Each Country/Region will have different language options to choose from.' })}</p>
                      </div>
                      <div className="d-flex justify-content-center gap-3 mt-2">
                      
                        <Select
                          clearIcon={false}
                          separateLabel
                          showSearch
                          onSearch={onCountrySearch}
                          options={countryOptions}
                          id="initiate-country"
                          label={t('HPI.Country',{defaultValue:'Country'})}
                          placeholder={t('HPI.Dropdown.DefaultText',{defaultValue:'Please select'})}
                          placement="bottom"
                          onChange={(selectedOption) => {
                            setCountry([selectedOption.value]);
                            buttonDisableCheck(selectedOption.value,"country");
                            onChangeCountry([selectedOption]);
                          }}
                          value={country}
                        />
                        
                        <Select
                          clearIcon={false}
                          separateLabel
                          showSearch
                          onSearch={onLanguageSearch}
                          options={languageOptions}
                          id="initiate-language"
                          label={t('HPI.InitiateChat.Language',{defaultValue:'Language'})}
                          placeholder={t('HPI.InitiateChat.SelectLanguage',{defaultValue:'Select Language'})}
                          placement="bottom"
                          onChange={(selectedOption) => {
                            setLanguage([selectedOption.value])
                            buttonDisableCheck(selectedOption.value,"language");
                          }}
                          value={language}
                        />
                        
                      </div>
                    </Modal>
                  </div>

                </Container>
              }
              />
           
          </div>
          <div>
            <Card
              background="filled"
              customStyle={"background-color:transparent;"}
              border="none"
              content={
                <Container className="card-container top-0" >
                  <div className="d-flex flex-column gap-3">
                    {pageLoad?.lblChatError!=null && pageLoad?.lblChatError.trim() != "" ? (
                      <div>
                        <span className="text-danger">{pageLoad?.lblChatError}</span>
                      </div>
                    ) : ("")}
                    {pageLoad?.ServiceResponse ? (
                      <div className="row">
                        <div className="ml-3 col-md-12 px-0 text-start d-flex flex-row gap-2 align-items-end flex-wrap">
                          <div className="subtitle-large support-option" dangerouslySetInnerHTML={{ __html: t("HPI.ChatwarrantyValidation.SupportOptions", {defaultValue: `<h2>Support Options:</h2> <label>Working hours Description:</label>`}) }}> 
                          </div>
                          <span className="body-large mb-2">{pageLoad?.spnwhDesc}</span>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}

                    {pageLoad?.hdnIsChatOpen==='1' ? (<>
                      <div className="row">
                        <div className="ml-3 col-md-12 px-0 text-start flex-wrap">
                          <h5 className="subtitle-large initiate-chat-support">                            
                            <span className="body-regular" dangerouslySetInnerHTML={{ __html: t("HPI.ChatwarrantyValidation.Initiatechatsupport", {defaultValue: `<h2>Initiate chat support</h2><p id="pnlConfirmCountry">Please supply a brief problem description to help our support technicians provide you with optimal service.</p>`}) }}>                    
                            </span>
                          </h5>
                        </div>
                      </div>
                      <div className="row">
                        <div className="ml-3 col-md-12 px-0 text-start">
                          <h5 className="subtitle-regular">
                          {t("HPI.ChatwarrantyValidation.Problemdescription",{ defaultValue: 'Problem description ' })} <span className="text-danger">*<br/></span>
                            <span className="body-large">
                                {t("HPI.ChatwarrantyValidation.chatdescription",{ defaultValue: 'Provide a detailed description of the symptoms observed, error messages encountered and the programs, command or devices involved.' })}
                            </span>
                          </h5>
                        </div>
                      </div>
                      <div>
                        <TextArea
                          value={problemDescription}
                          maxLength={500}
                          name="problemdescription"
                          required
                          placeholder={t('HPI.InitiateChat.Placeholder.ProblemDescription',{defaultValue:'Enter problem description'})}
                          onChange={(value) => {
                            setProblemDescription(value);
                            handleChange(value);
                          }}
                          error={errors["problemdescription"] ? true : false}
                          helperText={
                            errors["problemdescription"]
                              ? errors["problemdescription"]
                              : ""}
                        />
                        <div className="text-end">
                          <span>{problemDescription?.length}/500</span>
                        </div>
                      </div>
                    </>
                    ) : ("")}

                  </div>
                </Container>
              }
            />
            <Card
              background="filled"
              customStyle={"background-color:transparent;"}
              border="none"
              content={
                <Container className="card-container bg-clr-without-margin top-0">
                  <div className="d-flex gap-3 justify-content-end mb-4">
                    <Button
                      appearance="secondary"
                      onClick={cancelBtn}
                    >
                      {t("HPI.CallMeForm.ContactOptions",{ defaultValue: 'Back to case details' })}
                    </Button>
                    {!(pageLoad?.hdnIsChatOpen==0) ? (<Button
                      onClick={handleSubmit}
                    >
                      {t("HPI.Button.StartChat",{ defaultValue: 'Start Chat' })}
                    </Button>) : ("")}

                  </div>
                </Container>
              }
            />
          </div>
        </div>
        
      </Container>

  </>);

};